export default __webpack_public_path__ + "static/media/add_logo.5dbf6606.svg";